
import { Component, Prop, Vue} from 'vue-property-decorator';
import Destination from '../Passenger/models/Destination';
import { Organization } from '../../models/Organization';
import AddTenantDialog from '@/components/Organization/AddTenantDialog.vue';
import User from '../../models/User';

@Component({
  components: {
    AddTenantDialog,
  }
})
export default class OrganizationAuthTenantsPage extends Vue{
  /*tslint:disable max-line-length*/
  search: string = '';

  addTenantDialogVisible = false;

  pagination = {
    rowsPerPage: 10 // -1 for All,
  }
  
  get organizationId() {
    return this.$router.currentRoute.params.organizationId;
  }

  get organizationAuthTenants(): Destination[] {
    if (this.$store.state.organization.organizations) {
      return this.$store.state.organization.organizations
      .find(o => o.id === this.organizationId).authTenants;
    }
    return [];
  }

  get headers() {
    const headers = [
      { text: this.$t('organization.authTenant.name', 'Name'), value: 'name', align: 'left', sortable: true },
      { text: this.$t('organization.authTenant.externalTenantId', 'Tenant ID'), value: 'externalTenantId', align: 'left', sortable: true },
      { text: this.$t('organization.authTenant.type', 'Type'), value: 'typeName', align: 'left', sortable: true },
      // { text: this.$t('organization.authTenant.instances', 'Service providers'), value: 'movitInstanceName', align: 'left', sortable: true },
    ];
    return headers;
  }

  get isAdminUser() {
    const organization = this.$store.state.organization.organizations.find(o => o.id === this.organizationId) as Organization;
    const user = this.$store.state.user.me as User;
    return organization.administratorIds.some(id => id === user.id);
  }
}
